import { Vue, Component, Prop } from 'vue-property-decorator'
import { AxiosResponse } from 'axios'
import { CommonExportType } from '@/api/resources/common/shared/models/common.models'
import { SupportedFileType } from '@/shared/models/common.models'

@Component
export default class VtReportExportButtons extends Vue {
    @Prop({ type: String, required: true })
    readonly source!: string

    @Prop({ type: Function, required: true })
    readonly exportReport!: (exportType: CommonExportType) => Promise<AxiosResponse<Blob> | null>

    @Prop({ type: Boolean, default: false })
    readonly disabled!: boolean

    async onExportPdf() {
        const response = await this.$_toCallSecure(this.exportReport(CommonExportType.PDF))
        if (response) {
            const blob = response.data
            if (blob) {
                const openFileParams = {
                    blob,
                    type: SupportedFileType.PDF
                }
                this.$_openFile(openFileParams)
            }
        }
    }

    async onExportExcel() {
        const response = await this.$_toCallSecure(this.exportReport(CommonExportType.EXCEL))
        if (response) {
            const blob = response.data
            const fileName = this.$_getFilenameFromHeaderRequest(response)
            if (blob && fileName) {
                this.$_downloadFile(blob, fileName, SupportedFileType.EXCEL)
            }
        }
    }
}
